import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {DataManagerService} from '../data/services/DataManager/data-manager.service';
import {AiReportsActionDirective} from './ai-reports.action';
import {AppConstants} from '../shared/constants/app-constants';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
    selector: 'app-ai-reports',
    templateUrl: './ai-reports.component.html',
    styleUrls: ['./ai-reports.component.css'],
    standalone: false
})
export class AiReportsComponent extends AiReportsActionDirective implements OnInit {
  _router: Router;
  externalUrl: any;

  constructor(router: Router, private _sanitizer: DomSanitizer, dataManager: DataManagerService) {
    super();

    this._router = router;
    this.router = router;
    this.dataManager = dataManager;
    this._apiGetUrl = AppConstants.BASE_URL + '/get-merchant-dashboard-q-bar';
  }

  ngOnInit(): void {
    this.loadFlag = true;
    this.getPageData();
  }

  protected passPageData(response: any) {
    this.loadFlag = false;
    // The v1 API wraps payloads as `{ data: ... }`; fall back to the raw response
    // for a bare-string reply so either shape works.
    const url = (response && response.data) ? response.data : response;
    this.externalUrl = (typeof url === 'string' && url)
      ? this._sanitizer.bypassSecurityTrustResourceUrl(url)
      : null;
  }

  protected passApiError(error: any) {
    this.loadFlag = false;
    this.externalUrl = null;
  }

}
